<ResultsHeaderText/>
<div class="flex gap-half">
    <label for="sort-by" class="sr-only">
        <small>
            Sort By
        </small>
    </label>
    <select id="sort-by"
        class="border-0 cursor-pointer w-auto pr-1.5 xs:!pr-2 lg:!pr-[2.5rem] px-half py-qtr text-center md:text-left md:px-1 text-sm lg:text-base lg:w-auto lg:max-w-[160px] bg-transparent md:bg-white md:py-half md:border md:border-gray-400 md:hover:border-primary md:transition md:ease-in-out md:duration-150"
        v-model="customSort" @change="queryParams.updateParamString('customSort', $event.target.value)">
        <option value="">Sort By</option>
        <option value="ORM_MinPrice">Price &#8595;</option>
        <option value="ORM_MinPrice_DESC">Price &#8593;</option>
        <option value="ORM_Name">Name (A-Z)</option>
        <option value="ORM_Name_DESC">Name (Z-A)</option>
    </select>

    <button class="button small white-mobile-hollow-desktop shadow-lg md:shadow-none w-[130px] md:mb-0 fixed md:relative bottom-1 md:bottom-auto left-0 md:left-0 right-0 md:right-0 mx-auto z-[999] md:z-auto" v-on:click="toggleMap" v-if="!mapStore.showMap">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-1.5 h-1.5 inline-block">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
        </svg>
        Show Map
    </button>
</div>
